import { createStore } from "owa-satcheljs";

interface ClipboardUtilsStore {
    clipboardWritable: boolean;
    clipboardReadable: boolean;
}

const defaultStore: ClipboardUtilsStore = {
    clipboardWritable: true,
    clipboardReadable: true,
};

export const getStore: () => ClipboardUtilsStore = createStore<ClipboardUtilsStore>("owaClipboardUtilsStore", defaultStore);
